import * as R from "ramda";
import React, {Component} from "react";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import MasterLogistikTable from "../common/masterLogistikTable";
import {formGroupSeries, tableConfig} from "../config";
import MasterLogistikMotorSeriesModifying from "./modal/MasterLogistikMotorSeriesModifying";
import Api from "../../../../Services/Api";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL} from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";

class MasterLogistikMotorSeries extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = tableConfig.series;
        this.state = {
            modifyingVisible: false,
            selectedData: null,
            dataSubSegmenDDL: [],
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataSeries();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = async (index) => {
        this.handleTriggerLoading();
        if (!this.state.modifyingVisible) {
            await this.fetchDataSubSegmen();
        }

        if (!R.isNil(index)) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getSeriesById,
                menuName: "Master Logistik Motor - Series",
                setError: this.props.setError,
                args: this.state.dataTable[index].id,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...res.data.data,
                        idSubSegment: mapToObjectDDL(
                            res.data.data.subSegmentDTO.subSegmentName,
                            res.data.data.subSegmentDTO.id
                        )
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }

        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            idSubSegment: getValueFromDDL(formGroup, "idSubSegment"),
        };

        let api;
        if (!R.isNil(this.state.selectedData)) {
            api = await Api.create("NAGAMAS_MASTER_DATA").updateSeries;
        } else {
            api = await Api.create("NAGAMAS_MASTER_DATA").saveSeries;
        }
        let res = await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Logistik Motor - Series",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleModifyingModalVisibility();
            await this.fetchDataSeries({
                paramFilters: {},
                page: this.state.pagination.page,
                limit: this.state.pagination.limit,
            });
        }

        this.handleTriggerLoading();
    };

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        data.status = value ? "ACTIVE" : "INACTIVE";
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusSeries,
            menuName: "Master Logistik Motor - Series",
            setError: this.props.setError,
            args: {id: data.id, status: data.status},
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.fetchDataSeries({
                paramFilters: {},
                page: this.state.pagination.page,
                limit: this.state.pagination.limit,
            });
        }
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangePage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        await this.fetchDataSeries({paramFilters: {}, page: page, limit: limit});
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        await this.fetchDataSeries({paramFilters: {}, page: page, limit: limit});
        this.handleTriggerLoading();
    }

    fetchDataSeries = async (body) => {
        this.setState((prevValue) => ({...prevValue, pagination: {...prevValue.pagination, count: 0}}));
        let req = body && Object.keys(body).length > 0
            ? body :
            {
                paramFilters: {},
                page: 1,
                limit: 5,
            };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSeriesByParam,
            menuName: "Master Logistik Motor - Series",
            setError: this.props.setError,
            args: req,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data,
                pagination: {
                    ...prevState.pagination,
                    count: res.data.totalData,
                    page: req.page,
                    limit: req.limit,
                },
            }));
        }
    }

    fetchDataSubSegmen = async () => {
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSubSegmen,
            menuName: "Master Logistik Motor - Series",
            setError: this.props.setError,
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataSubSegmenDDL: response.data.data.map(item => mapToObjectDDL(item.subSegmentName, item.id)),
            }));
        }
    }

    render() {
        return (
            <>
                <MasterLogistikTable
                    tableConfig={this.tableConfig}
                    menuAccess={this.props.menuAccess}
                    data={this.state.dataTable}
                    onEdit={this.handleModifyingModalVisibility}
                    onChangeStatus={this.handleChangeStatus}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    pagination={this.state.pagination}
                    additionalButtons={
                        this.props.menuAccess && this.props.menuAccess.createAccess && (
                            <SimpleButton
                                onClick={() => this.handleModifyingModalVisibility()}
                                icon={<i className="fa fa-plus margin-right-10px"></i>}
                                text={"Tambah"}
                            />
                        )
                    }
                />

                {this.state.modifyingVisible && (
                    <MasterLogistikMotorSeriesModifying
                        formGroup={formGroupSeries}
                        initialValues={this.state.selectedData}
                        selectedData={this.state.selectedData}
                        dataSubSegmenDDL={this.state.dataSubSegmenDDL}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default MasterLogistikMotorSeries;
